import { render, staticRenderFns } from "./treeMenu.vue?vue&type=template&id=44010ef0"
import script from "./treeMenu.vue?vue&type=script&lang=js"
export * from "./treeMenu.vue?vue&type=script&lang=js"
import style0 from "./treeMenu.vue?vue&type=style&index=0&id=44010ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports